import { render, staticRenderFns } from "./supplier.vue?vue&type=template&id=0a40b3e4"
import script from "./supplier.vue?vue&type=script&lang=js"
export * from "./supplier.vue?vue&type=script&lang=js"
import style0 from "./supplier.vue?vue&type=style&index=0&id=0a40b3e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports